import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import "./Offer.css";

const Offer = () => {
  return (
    <Container id="offer">
      <Row>
        <Col>
          <h1 className="offer-h1-mini">
            Jak zamówić legitymacje ucznia lub służbową nauczyciela?
          </h1>
          <h1 className="offer-h1">
            Etapy <span className="offer-span">zamówienia</span> legitymacji
            szkolnych ucznia lub służbowej nauczyciela.
          </h1>
        </Col>
      </Row>
      <Row>
        <Col className="offer-list">
          <ul>
            <li>
              Załóż konto szkoły za pomocą adresu e-mail podanego w RSPO
              (Rejestr szkół i placówek oświatowych) na stronie:{" "}
              <a href="/">Dodaj użytkownika</a>. Potwierdź rejestrację klikając
              w link aktywacyjny, który otrzymasz na podany adres e-mail.
            </li>
            <li>
              Zaloguj się do systemu: <a href="/">Logowanie</a> i połącz adres
              e-mail z numerem RSPO. Jeśli adres e-mail i numer RSPO są
              prawidłowe wyświetlą się dane szkoły lub placówki edukacyjnej.
            </li>
            <li>
              Sprawdź poprawność danych szkoły i uzupełnij ewentualnie brakujące
              dane i zatwierdź generując umowę. Podpisz i wyślij umowę na adres
              e-mail: <strong>umowy@strefadlaedukacji.pl</strong>.
            </li>
            <li>
              Prześlemy podpisaną przez nas umowę w ciągu dwóch dni roboczych i
              aktywujemy konto umożliwiając dokonywanie zamówień.
            </li>
            <li>
              Złóż zamówienie w systemie dodając dane uczniów lub nauczycieli.
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};

export default Offer;
